import React, { useEffect, useContext } from 'react';
import { CTA, ImageType } from 'utils/types';
import { ProductInfoContext } from '../../../templates/pdp';

import MoreTestsSection from '../../../components/PDP/MoreTestsSection';

export interface ContentSection {
  title?: string;
  headline?: string;
  subHeadline?: string;
  slug?: string;
  description?: {
    description: string;
  };
  desktopImages?: ImageType[];
  mobileImages?: ImageType[];
  modalButtonText?: string;
  modalTitle?: string;
  embeddedVideoLink?: string;
}
export interface MoreTestsContainerProps {
  content: {
    headline: string;
    cta: CTA;
    listOfContentSections: {
      slug: string;
    }[];
  };
}

export const MoreTestsContainer: React.FC<MoreTestsContainerProps> = ({
  content,
}) => {
  if (!content) {
    return null;
  }

  const { productsBySlug } = useContext(ProductInfoContext);

  const { headline, cta, listOfContentSections } = content;

  const formattedListOfContent = listOfContentSections.map(item => {
    const product = productsBySlug[item.slug];

    return {
      heading: product.name,
      subheading: `$${Number(product.price).toFixed()}`,
      image: product.boxImage.fluid,
      number: product.productId,
      slug: product.slug || '',
      showRating: false,
    };
  });

  // necessary for SSR https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [hasMounted, setHasMounted] = React.useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!hasMounted) {
    return null;
  }

  return (
    <MoreTestsSection
      headline={headline}
      mainCta={cta}
      listOfContent={formattedListOfContent}
      productsBySlug={productsBySlug}
    />
  );
};

export default MoreTestsContainer;
